module.exports = __webpack_public_path__ + "static/img/pprocess4.bbb49f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pprocess4.png
// module id = x1iM
// module chunks = 1